import { Box, Container } from '@mui/material';
import DashboardProjects from './DashboardProjects';

const HomeContent = () => {
  return (
    <Container maxWidth="xl" className="mb-4 mt-3">
      <Box>
        <DashboardProjects />
      </Box>
    </Container>
  );
};

export default HomeContent;
